import Modal from "@src/components/UIElements/Modal";
import { newWebEngage } from "@src/utils/webEngageEvent";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import styles from "./VideoPlayerBottomSheet.module.scss";


import Player from "@src/ReactPlayer/Player";
import Backdrop from "@src/ReactPlayer/Backdrop";
import { useState } from "react";

const VideoPlayerBottomSheet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showPlayer, setShowPlayer] = useState(false);

  const state = useSelector(
    (state) => state.bottomSheetReducer?.showCourseLockedBottomSheet
  );
  const videoPlayerContent = useSelector(
    (state) => state?.bottomSheetReducer?.videoPlayerContent);
  const overViewData = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course
  );
  const paymentData = useSelector((state) => state?.overviewReducer);
  return (
    <Modal
      customClass="videoPlayerWrapper"
      showModal={state}
      handleClose={() => {
        dispatch(actionCreator.toggleVideoBottomSheet({
          value: false,
          data: {}
        }));
      }}
    >
      <div className={styles.CourseLocked}>
        <Player
          item={videoPlayerContent}
          handleIframeClose={setShowPlayer}
          isExhaustedDisabled={true}
        />
        <Backdrop
          show={false}
          toggle={setShowPlayer}
          backgroundColor={false}
        />
      </div>
    </Modal>
  );
};

export default VideoPlayerBottomSheet;
